// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SaveInactive: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 15"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="14"
            height="15"
            fill="currentColor"
        >
            <path
                d="M259.125,413.375 L255.474609,413.375 L254.237305,414.612305 C253.907813,414.941797 253.467578,415.125 253,415.125 C252.532422,415.125 252.093281,414.943 251.762695,414.612305 L250.525391,413.375 L246.875,413.375 C246.391836,413.375 246,413.766836 246,414.25 L246,416.875 C246,417.358164 246.391836,417.75 246.875,417.75 L259.125,417.75 C259.608164,417.75 260,417.358164 260,416.875 L260,414.25 C260,413.766015 259.608985,413.375 259.125,413.375 Z M257.8125,416.21875 C257.451562,416.21875 257.15625,415.923438 257.15625,415.5625 C257.15625,415.201562 257.451562,414.90625 257.8125,414.90625 C258.173438,414.90625 258.46875,415.201562 258.46875,415.5625 C258.46875,415.923438 258.173438,416.21875 257.8125,416.21875 Z M252.382031,413.992969 C252.551563,414.165234 252.775781,414.25 253,414.25 C253.224219,414.25 253.447891,414.164551 253.618515,413.993652 L257.118515,410.493652 C257.460039,410.151855 257.460039,409.598145 257.118515,409.256348 C256.776719,408.914551 256.222734,408.914551 255.881211,409.256348 L253.875,411.264062 L253.875,404.625 C253.875,404.141836 253.483164,403.75 253,403.75 C252.516016,403.75 252.125,404.141836 252.125,404.625 L252.125,411.264062 L250.117969,409.257031 C249.776445,408.915234 249.222461,408.915234 248.880664,409.257031 C248.539141,409.598828 248.539141,410.152539 248.880664,410.494336 L252.382031,413.992969 Z"
                opacity=".66"
                transform="translate(-246 -403)"
            />
        </svg>
    );
};

export default React.memo(SaveInactive);
